module.exports = __webpack_public_path__ + "fonts/effect-mercs-for-money-93aef5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/effect-mercs-for-money.svg
// module id = 790
// module chunks = 0